// socketManager.js
import io from 'socket.io-client';

class SocketManager {
  constructor() {
    this.socket = null;
    this.isConnected = false;
  }

  initializeSocket() {
    if (!this.socket) {
      try {
        console.log("Socket URL:", process.env.REACT_APP_SOCKET_BASE_URL);
        this.socket = io(process.env.REACT_APP_SOCKET_BASE_URL, {
          path: "/socket/socket.io",
          transports: ["websocket"]
        });
        this.socket.on("connect", () => {
          this.isConnected = true;
          console.log("Connected to Socket.IO server");
        });

        this.socket.on("disconnect", () => {
          this.isConnected = false;
          console.log("Disconnected from Socket.IO server");
        });

        // Automatically connect if not already connected.
        this.socket.connect();
      } catch (error) {
        console.error("Socket initialization error:", error);
      }
    }
  }

  isSocketConnected() {
    return this.isConnected;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.isConnected = false;
    }
  }

  reconnect() {
    if (this.socket && !this.isConnected) {
      this.socket.connect();
    }
  }

  addEventListener(event, listener) {
    if (this.socket) {
      this.socket.on(event, listener);
    }
  }

  removeEventListener(event) {
    if (this.socket) {
      this.socket.off(event);
    }
  }
}

// Export as a singleton.
export default new SocketManager();
